import { pageHead } from "@/lib/seoPolicy";
import { createFileRoute } from "@tanstack/react-router";
import AdminPageLayouts from "@/pages/admin/AdminPageLayouts";

export const Route = createFileRoute("/admin/page-layouts")({
  head: () => pageHead("Admin \u2014 Page Layouts \u2014 Modern Fence Install", "Private Modern Fence Install account and management page.", undefined, true),
  component: AdminPageLayouts,
});
